import { query_anagrafiche_byCf, query_anagrafiche_byCf_PG, query_anagrafiche_byFascicolo, query_anagrafiche_byFiscalCode, query_ifThereAreDuplicates, query_anagrafiche_docInScadenza } from "../query/anagraficaQueries";
import {useQuery,useMutation} from "@1f/react-sdk";
import sharedDatasInstance from "../sharedDatas";
import { GET_ANAGRAFICA_DUPLICATES, GET_ANAGRAFICHE_ORFANE, getAllAnagraficaVersions, getAnagraficaFromDB, query_anagrafiche_malformed_Piva } from "../query/anagraficaQueries";
import { deleteAnagrafica, deleteAnagraficaDuplicates, downgradeAnagraficaVersion, postAnagrafica, updateAnagrafica, upgradeAnagraficaVersion } from "../mutations/anagraficaMutations";
import { buildAnagraficaSearchFilter, isAFiscalCode } from "../helpers/anagraficaHelpers";
import { mutation_validateCodiceFiscale, mutation_validatePartitaIva } from "../mutations/validationMutations";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";
import { query_getAnagraficheByFascicolo } from "../query/fascicoloQueris";
import { query_ppe_fascicoli_anagrafiche_stats, query_rischio_fascicoli_anagrafiche_stats } from "../query/statsQueries";

export const useAnagraficaSearchQuery = (query) => {
    const api = useQuery(query, {}, { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" });
    return {
        ...api,
        fetch: (variables) => api.fetch({
            tenantId: variables.tenantId,
            searchFilter: buildAnagraficaSearchFilter(variables),
        }),
    };
};

export const AnagraficaApi = () => {
    const tenantId = sharedDatasInstance.getPropertyByName("tenantId");
    const loggedUserId = sharedDatasInstance.getPropertyByName("userId");
    const aziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
    const errorApiHelpers = apiErrorHelper();
    const apiCheckDuplicates = useQuery(
        query_ifThereAreDuplicates,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const apiGetAnagraficaDuplicate = useQuery(
        GET_ANAGRAFICA_DUPLICATES,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )    
    const apiAnagraficaByFascicolo = useQuery(
        query_anagrafiche_byFascicolo,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAnagraficaById = useQuery(
        getAnagraficaFromDB,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAnagrafichePFByCf = useQuery(
        query_anagrafiche_byFiscalCode,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAnagrafichePGByCfAndPiva = useAnagraficaSearchQuery(query_anagrafiche_byCf_PG);
    const apiAnagrafichePFBySurname = useAnagraficaSearchQuery(query_anagrafiche_byCf);
    const apiGetAllAnagraficaVersions = useQuery(
        getAllAnagraficaVersions,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }  
    )
    const apiPostAnagrafica = useMutation(
        postAnagrafica, 
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiUpdateAnagrafica = useMutation(
        updateAnagrafica,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiUpdateAnagraficaVersion = useMutation(
        upgradeAnagraficaVersion,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiDowngradeAnagraficaVersion = useMutation(
        downgradeAnagraficaVersion,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiDeleteAnagraficaDuplicates = useMutation(
        deleteAnagraficaDuplicates,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiVeirfyCf = useMutation(
        mutation_validateCodiceFiscale,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiVerifyPIva = useMutation(
        mutation_validatePartitaIva,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiDeleteAnagrafica = useMutation(
        deleteAnagrafica,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )    
    const apiGetAnagFascicolosByFascicoloId = useQuery(
        query_getAnagraficheByFascicolo,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiGetAnagraficheOrfane = useQuery(
        GET_ANAGRAFICHE_ORFANE,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const getMalformedPivaAnag = useQuery(
        query_anagrafiche_malformed_Piva,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiRischioFascicoliAnagraficheStats = useQuery(
        query_rischio_fascicoli_anagrafiche_stats,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiPPEFascicoliAnagraficheStats = useQuery(
        query_ppe_fascicoli_anagrafiche_stats,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAnagDocInScadenza = useQuery(
        query_anagrafiche_docInScadenza,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );

    const CheckIfThereAreDuplicates = async () => {    
        try {
            let duplicatesResponse = await apiCheckDuplicates.fetch({
                tenantId: tenantId
            });
            if(!duplicatesResponse.data.errors){
                return duplicatesResponse.data.data.ifThereAreDuplicates
            }
        } catch (error) {
            throw new Error("Impossibile verificare la presenza di anagrafiche duplicate")
        }       
    }
    const GetDuplicateAnagrafica = async () => {
        try {
            let duplicatesResponse = await apiGetAnagraficaDuplicate.fetch({                
                tenantId: tenantId
            });
            if(!duplicatesResponse.data.errors){
                return duplicatesResponse.data.data.getAnagraficaDuplicates
            }
        } catch (error) {
            if (error.originalError?.extensions?.internal?.response?.status === 401) {
                return null;
            }
            throw new Error("Impossibile recuperare le anagrafiche duplicate")
        }
    }
    const GetAnagraficheByFascicoloId = async (fascicoloId)=>{
        try {
            const anagResponse = await apiAnagraficaByFascicolo.fetch({
                fascicoloId: fascicoloId,
            });
            if (!anagResponse.data.errors){
                let allAnagIds = anagResponse.data.data.anagrafica.map(anag => anag.Id);
                let toReturnAnag = []
                for (const anagId of allAnagIds) {
                    let anag = await GetAnagraficaById(anagId);
                    if (anag) {
                        toReturnAnag.push(anag);
                    }
                }
                return toReturnAnag;
            }
        } catch (error) {
            throw new Error("Impossibile recuperare le anagrafiche")
        }
    }
    const GetAnagraficaById = async (anagraficaId) => {
        try {
            let anagrafica = await apiAnagraficaById.fetch({                
                id: anagraficaId,
                userId: loggedUserId
            });
            if(!anagrafica.data.errors){
                return anagrafica.data.data.getAnagraficaFromDB
            }
        } catch (error) {
            throw new Error("Impossibile recuperare l' anagrafica")
        }
    }
    const GetAnagraficaFromDB = async (codiceFiscale,partitaIva,isPG) => {
        try {       
            let anagraficheFromDB = null 
            if(isAFiscalCode(codiceFiscale)){
                if (!isPG) {
                    anagraficheFromDB = await apiAnagrafichePFByCf.fetch({
                        tenantId: tenantId,
                        cf: codiceFiscale + "%",
                    });                                    
                } else {
                    anagraficheFromDB = await apiAnagrafichePGByCfAndPiva.fetch({
                        tenantId: tenantId,
                        cf: "%" + codiceFiscale + "%",
                        pIva: "%" + partitaIva + "%",
                        denominazione: "%%",
                    });
                }
            } else {
                anagraficheFromDB = await apiAnagrafichePFBySurname.fetch({
                    tenantId: tenantId,
                    cf: "%%",
                    cognome: "%" + codiceFiscale + "%",
                    nome: "%%",
                })
            }
            if(!anagraficheFromDB.data.errors){
                let anagrafiche = [];
                for (const anag of anagraficheFromDB.data.data.anagrafica) {
                    let cleanAnag = await GetAnagraficaById(anag.Id);
                    anagrafiche.push(cleanAnag);
                }
                
                return anagrafiche;
            }
        } catch (error) {
            throw new Error("Impossibile recuperare l'anagrafica")
        }
    }
    const GetAllAnagraficaVersions = async (anagraficaId) => {
        try {
            let allAnagVersions = await apiGetAllAnagraficaVersions.fetch({
                id: anagraficaId,
                userId: loggedUserId                
            });
            if(!allAnagVersions.data.errors){
                return allAnagVersions.data.data.getAnagraficaVersionsFromDB
            }
        } catch (error) {
            throw new Error("Impossibile recuperare le versioni dell'anagrafica")
        }
    }
    const GetMalformedPivaAnagrafica = async (partitaIva) => {
        try {
            let malformedPivaResponse = await getMalformedPivaAnag.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
            });
            if(malformedPivaResponse && malformedPivaResponse.data){
                return malformedPivaResponse.data.data.anagrafica
            }                
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile recuperare le anagrafiche con partita IVA malformata");
        }
    }
    const GetDistinctRischioAnagStats = async (tenantId,aziendaId) => {
        try {
            let allRischioAnag = []
            let statsResponse = await apiRischioFascicoliAnagraficheStats.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
            });
            if(statsResponse && statsResponse.data) {
                allRischioAnag = statsResponse.data.data.fascicolo.flatMap((fascicolo) =>
                    fascicolo.anagrafica_fascicolos.map((item) => item.anagrafica)
                );    
                return allRischioAnag ? [...new Map(allRischioAnag.map((item) => [item.Cf, item])).values()] : null;
            }
        } catch (error) {
            throw new Error("Impossibile recuperare le statistiche dei rischi delle anagrafiche" + error.message);
        }
    }
    const GetDistinctPPEAnagStats = async (tenantId,aziendaId) => {
        try {
            let allPPEAnag = []
            let statsPPEResponse = await apiPPEFascicoliAnagraficheStats.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
            });
            if(statsPPEResponse && statsPPEResponse.data) {
                allPPEAnag = statsPPEResponse.data.data.fascicolo.flatMap((fascicolo) =>
                    fascicolo.anagrafica_fascicolos.map((item) => item.anagrafica)
                );    
                return allPPEAnag ? [...new Map(allPPEAnag.map((item) => [item.Cf, item])).values()] : null;
            }
        } catch (error) {
            throw new Error("Impossibile recuperare le statistiche PPE delle anagrafiche" + error.message);
        }
    }
    const GetAnagraficheFascicoliDocScad = async (tenantId,aziendaId) => {
        try {
            let anagDocScadResponse = await apiAnagDocInScadenza.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
            });
            if(anagDocScadResponse && anagDocScadResponse.data) {
                return anagDocScadResponse.data.data.fascicolo
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile recuperare le anagrafiche con documenti in scadenza");
        }
    }
    const PostAnagrafica = async (anagrafica) => {
        try {
            let cleanedAnagrafica = removeFields(anagrafica,["anagraficaFascicoli"]);
            let anagraficaResponse = await apiPostAnagrafica.fetch({
                userId: loggedUserId,
                tenantId: tenantId,
                aziendaId: aziendaId,
                dataInput: cleanedAnagrafica    
            })
            if(!anagraficaResponse.data.errors){
                return anagraficaResponse.data.data.postAnagrafica
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile creare l'anagrafica");
        }
    }
    const UpdateAnagrafica = async (anagrafica) => {
        try {
            let cleanedAnagrafica = removeFields(anagrafica,["anagraficaFascicoli"]);
            let anagraficaResponse = await apiUpdateAnagrafica.fetch({
                id: anagrafica.id,
                userId: loggedUserId,                
                aziendaId: aziendaId,
                dataInput: cleanedAnagrafica
            })
            if(!anagraficaResponse.data.errors){
                return anagraficaResponse.data.data.updateAnagrafica
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile aggiornare l'anagrafica");
        }
    }
    const UpgradeAnagraficaVersion = async (anagrafica) => {
        try {
            let cleanedAnagrafica = removeFields(anagrafica,["anagraficaFascicoli"]);
            let response = await apiUpdateAnagraficaVersion.fetch({
                id: anagrafica.id,
                userId: loggedUserId,
                aziendaId: aziendaId,
                dataInput: cleanedAnagrafica
            })
            if(!response.data.errors){
                return response.data.data.upgradeAnagraficaVersion
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile aggiornare la versione dell'anagrafica");
        }
    }
    const DowngradeAnagraficaVersion = async (anagraficaId) => {
        try {            
            let response = await apiDowngradeAnagraficaVersion.fetch({
                id: anagraficaId,
                userId: loggedUserId,
                aziendaId: aziendaId,
            })
            if(!response.data.errors){
                return response.data.data.downgradeAnagraficaVersion
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile effettuare il downgrade della versione dell'anagrafica");
        }
    }
    const DeleteAnagrafica = async (anagIdToDelete) => {
        try {
            let deletionAngResponse = await apiDeleteAnagrafica.fetch({
                anagraficaId: anagIdToDelete,
                tenantId: tenantId
            })
            if(deletionAngResponse && deletionAngResponse.data){
                return deletionAngResponse.data.data.deleteAnagrafica.deletedId > 0
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile eliminare l'anagrafica");
        }
    }
    const DeleteDuplicatesAnagrafiche = async (keepId, duplicateIds) => {
        try {
            let response = await apiDeleteAnagraficaDuplicates.fetch({
                tenantId: tenantId,
                keepId: keepId,
                duplicateIds: duplicateIds
            })
            // Controlla se ci sono dati validi nella risposta
            if(response?.data?.data?.deleteAnagraficaDuplicates){
                return response.data.data.deleteAnagraficaDuplicates
            }
            // Se non ci sono errori ma neanche dati, considera comunque come successo
            if(!response.data.errors){
                return { success: true, message: "Duplicati eliminati con successo" }
            }            
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile eliminare i duplicati dell'anagrafica");
        }
    }
    const VerifyCf = async (cf) => {
        try {
            let responseVerifyCf = await apiVeirfyCf.fetch({
                codiceFiscale: cf
            });
            if(!responseVerifyCf.data.errors){
                return responseVerifyCf.data.data.validateCodiceFiscale.isValid
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile verificare il codice fiscale");
        }
    }
    const VerifyPIva = async (pIva) => {
        try {
            let responseVerifyPIva = await apiVerifyPIva.fetch({
                partitaIva: pIva
            });
            if(!responseVerifyPIva.data.errors){
                return responseVerifyPIva.data.data.validatePartitaIva.isValid
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile verificare la partita IVA");
        }
    }
    const GetAnagFascicolosFromFascicoloId = async (fascicoloId) => {
        try {
            let responseAssociations = await apiGetAnagFascicolosByFascicoloId.fetch({
                fascicoloId: fascicoloId,
                includeTerminated: true
            });
            if(responseAssociations.data) {
                return responseAssociations.data.data.getAnagraficheByFascicolo;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile recuperare le anagrafiche collegate al fascicolo");
        }
    }
    const GetAnagraficheOrfane = async () => {
        try {
            let response = await apiGetAnagraficheOrfane.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId
            });
            if(!response.data.errors){
                return response.data.data.getAnagraficheOrfane;
            }
        } catch (error) {
            if(error.originalError?.message?.includes("not authorized")) {
                return [] 
            }
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile recuperare le anagrafiche orfane");
        }
    }
    function removeFields(obj, fieldsToRemove) {
        const result = { ...obj }; // copia l'oggetto per non modificarlo direttamente
        for (const field of fieldsToRemove) {
            delete result[field];
        }
        return result;
    }

    return {
        GetDuplicateAnagrafica,
        GetAnagraficheByFascicoloId,
        GetAnagraficaById,
        GetAnagraficaFromDB,
        GetAllAnagraficaVersions,
        GetMalformedPivaAnagrafica,
        GetDistinctRischioAnagStats,
        GetDistinctPPEAnagStats,
        GetAnagraficheFascicoliDocScad,
        PostAnagrafica,
        UpdateAnagrafica,
        UpgradeAnagraficaVersion,
        DowngradeAnagraficaVersion,
        DeleteAnagrafica,
        DeleteDuplicatesAnagrafiche,
        CheckIfThereAreDuplicates,
        VerifyCf,
        VerifyPIva,
        GetAnagFascicolosFromFascicoloId,
        GetAnagraficheOrfane
    }
}